/**
 * Shared status color utilities for Chip components
 */

/**
 * Get MUI Chip color for meeting status values
 */
export const getMeetingStatusColor = (status: string) => {
  switch (status) {
    case 'active':
      return 'primary';
    case 'done':
      return 'success';
    case 'cancelled':
      return 'error';
    case 'noshow':
      return 'warning';
    default:
      return 'default';
  }
};

/**
 * Get MUI Chip color for patient status values
 */
export const getPatientStatusColor = (status: string) => {
  switch (status) {
    case 'waiting_for_payment':
      return 'warning';
    case 'new':
      return 'info';
    case 'intake':
      return 'primary';
    case 'titration':
      return 'secondary';
    case 'titration_waiting_for_payment':
      return 'warning';
    case 'finish':
      return 'success';
    default:
      return 'default';
  }
};
